import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_error) {
    return { hasError: true };
  }

  componentDidCatch(_error, errorInfo) {
    console.error("error boundary", errorInfo);
    console.error("error", _error);
    throw new Error(errorInfo);
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback
      }
      return <div className="text-error">Ocurrio un error {`${this.props.errorMessage ? " en " + this.props.errorMessage : ""}`}</div>;
    }
    return this.props.children;
  }
}
export default ErrorBoundary;
